import { autocompleteClasses } from "@mui/material";
import type { Components, Theme } from "@mui/material/styles";
import { DROPDOWN_SURFACE } from "../dropdownSurface";

const staleMouseFocusSelector = `& .${autocompleteClasses.option}.${autocompleteClasses.focused}:not(.${autocompleteClasses.focusVisible}):not(:hover):not([aria-selected="true"])`;

export const MuiAutocomplete: Components<Theme>["MuiAutocomplete"] = {
  defaultProps: {
    // Default Autocomplete paper is elevation 1; bump to 8 so its shadow matches
    // the Select/SelectPopover dropdowns (both Popover-based, elevation 8).
    slotProps: { paper: { elevation: 8 } },
  },
  styleOverrides: {
    paper: DROPDOWN_SURFACE,
    listbox: {
      // MUI keeps the last mouse-hovered option as the highlighted option after
      // the cursor leaves the listbox. Hide that stale mouse highlight without
      // affecting keyboard focus or selected option styling.
      [staleMouseFocusSelector]: {
        backgroundColor: "transparent",
      },
    },
  },
};
